export interface ITaskValidationRowCol {
    field: string;
    errors: string[];
}

export class TaskValidationRowCol implements ITaskValidationRowCol {
    field: string;
    errors: string[];

    constructor();
    constructor(obj: ITaskValidationRowCol);
    constructor(obj?: any) {
        this.field = obj && obj.field || "";
        this.errors = obj && obj.errors || [];
    }
}